import { call, select, race, take, delay, put } from 'redux-saga/effects';
import { statusSuccess, statusFailed, actions } from '@grandvisionhq/state';
import { LensPackageStepContainer } from '../../../../steps/LensPackageStep/LensPackageStepContainer.js';
import '../../../actions.js';
import { loadMissingAddOns } from '../../../bundles/sagas.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getSelectedPackage, getFrameSku, getPackages, getSelectedLensType } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';
import { selectPackage } from '../../../configurations/actions.js';
import { fetchPackagesSuccess, fetchPackagesFailed } from '../../../bundles/actions.js';

const lensPackageStepBase = {
    *onEnter () {
        yield call(selectDefaultPackage);
    },
    *onNext () {
        const selectedPackage = yield select(getSelectedPackage);
        if (!selectedPackage) {
            return new Error(`Selecting a lens-package is required`);
        }
    },
    view: LensPackageStepContainer
};
const isSuccess = ({ lensTypeSku  })=>(a)=>actions.isType(a, fetchPackagesSuccess) && a.payload.lensTypeSku === lensTypeSku
;
const isFailed = ({ lensTypeSku  })=>(a)=>actions.isType(a, fetchPackagesFailed) && a.payload.lensTypeSku === lensTypeSku
;
function* selectDefaultPackage() {
    const selectedPackage = yield select(getSelectedPackage);
    if (!selectedPackage) {
        const frameSku = yield select(getFrameSku);
        if (!frameSku) {
            return;
        }
        let packages = yield select(getPackages);
        if (!statusSuccess(packages) && !statusFailed(packages)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const lensType = yield select(getSelectedLensType);
            if (!lensType) {
                return;
            }
            const [success] = yield race([
                take(isSuccess({
                    lensTypeSku: lensType.sku
                })),
                take(isFailed({
                    lensTypeSku: lensType.sku
                })),
                delay(30000, true), 
            ]);
            if (success) {
                packages = yield select(getPackages);
            }
        }
        if (statusSuccess(packages)) {
            var ref;
            /**
       * Select the cheapest product that has the 'default' attribute set to true
       * If no product is set as default, select the cheapest one
       */ let packageSku = (ref = packages.result[0]) === null || ref === void 0 ? void 0 : ref.sku;
            for (const product of packages.result){
                if (product.isDefault) {
                    packageSku = product.sku;
                    break;
                }
            }
            if (packageSku) {
                yield put(selectPackage({
                    frameSku,
                    packageSku,
                    reason: 'default selection'
                }));
            }
        }
    } else {
        yield call(loadMissingAddOns, selectedPackage.sku);
    }
}

export { lensPackageStepBase, selectDefaultPackage };
//# sourceMappingURL=lens-package.js.map
